import Loadable from '../../components/loadable';

const BookedEventsInSeriesModal = Loadable({
  loader: () => import('../../pages/calendar/booked_events_in_series_modal'),
  type: 'drawer',
});

angular.module('gym').value('BookedEventsInSeriesModal', BookedEventsInSeriesModal);
